import { render, staticRenderFns } from "./tsk-text.vue?vue&type=template&id=21b14a5d&scoped=true&"
import script from "./tsk-text.vue?vue&type=script&lang=js&"
export * from "./tsk-text.vue?vue&type=script&lang=js&"
import style0 from "./tsk-text.vue?vue&type=style&index=0&id=21b14a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b14a5d",
  null
  
)

export default component.exports